module.exports = __webpack_public_path__ + "ffd4a4fdd624a8a822f4c59692fa99bb.svg";